import { Activity } from '@apeiron/common'
import { SaleHistoryItem } from '@src/components/activities/SaleHistoryItem'
import { ActivityRoute } from '@src/constants/activity'
import { FC } from 'react'

const SaleHistoryList: FC<Props> = props => {
  const { histories, route } = props

  return (
    <>
      {histories.map((data, i) => {
        return (
          <SaleHistoryItem
            key={`${data.transaction.commitAt + i}`}
            saleHistory={data}
            route={route}
          />
        )
      })}
    </>
  )
}

type Props = {
  histories: Activity[]
  route: ActivityRoute
}

export default SaleHistoryList
